<template>
  <div class="login-card">
    <p class="card-title">{{ $t('form_createAccount') }}</p>
    <b-form @submit="onSubmit" autocomplete="off">
      <b-form-group class="mb-3 icon-relative" id="fieldset-1" :label="$t('form_name')" label-class="label-class"
        :invalid-feedback="$t('valid_nameNotEmpty')" :state="state">
        <b-input-group>
          <b-form-input v-model="name" :state="state" class="px-5"></b-form-input>
          <i class="fas fa-user input-icon"></i>
          <div class="input-group-append">
            <span class="input-group-text" :style="state === false ? 'border-color: #dc3545' : ''"></span>
          </div>
        </b-input-group>
      </b-form-group>
      <b-form-group class="mb-3" id="fieldset-2" :label="$t('form_phoneNumber')" label-class="label-class"
        :invalid-feedback="$t('valid_phoneNumberNotEmpty')" :state="state">
        <b-input-group>
          <b-form-input v-model="phone" :state="state" class="px-5"></b-form-input>
          <i class="fas fa-phone input-icon"></i>
          <div class="input-group-append">
            <span class="input-group-text" :style="state === false ? 'border-color: #dc3545' : ''"></span>
          </div>
        </b-input-group>
      </b-form-group>
      <b-form-group class="mb-0" id="fieldset-3" label="Email" label-class="label-class"
        :invalid-feedback="$t('valid_emailNotEmpty')" :state="stateEmail">
        <b-input-group>
          <b-form-input autocomplete="off" v-model="email" :state="stateEmail" class="px-5"></b-form-input>
          <i class="fas fa-envelope input-icon"></i>
          <div class="input-group-append">
            <span class="input-group-text" :style="stateEmail === false ? 'border-color: #dc3545' : ''"></span>
          </div>
        </b-input-group>
      </b-form-group>
      <p class="email-descrip">
        {{ $t('form_email_resetAccount') }}
      </p>
      <b-form-group class="mb-3" id="fieldset-4" :label="$t('form_password')" label-class="label-class"
        :invalid-feedback="$t('valid_passwordNotEmpty')" :state="statePass">
        <b-input-group>
          <b-form-input autocomplete="off" class="px-5" :type="`${showPass ? 'text' : 'password'}`" v-model="pass"
            :state="statePass"></b-form-input>
          <i class="fas fa-shield input-icon"></i>
          <div class="input-group-append">
            <span class="input-group-text py-0 px-3" :style="statePass === false ? 'border-color: #dc3545' : ''"
              style="cursor: pointer; background-color: none !important" @click="showPass = !showPass">
              <img v-if="showPass" src="/assets/image/icon/eye.svg" />
              <img v-else src="/assets/image/icon/eye-off.svg" />
            </span>
          </div>
        </b-input-group>
      </b-form-group>
      <b-form-group class="mb-3" id="fieldset-5" :label="$t('form_confirmPassword')" label-class="label-class"
        invalid-feedback="Mật khẩu không trùng khớp" :state="statePassRe">
        <div class="input-group mb-3">
          <b-form-input class="px-5" autocomplete="off" :type="`${showPassRe ? 'text' : 'password'}`"
            v-model="passRepeat" :state="statePassRe"></b-form-input>
          <i class="fas fa-shield input-icon"></i>
          <div class="input-group-append" style="border-color: red">
            <span class="input-group-text py-0 px-3" :style="statePassRe === false ? 'border-color: #dc3545' : ''"
              style="cursor: pointer" @click="showPassRe = !showPassRe">
              <img v-if="showPassRe" src="/assets/image/icon/eye.svg" />
              <img v-else src="/assets/image/icon/eye-off.svg" />
            </span>
          </div>
        </div>
      </b-form-group>
      <p v-if="error" class="m-0 text-danger" style="font-size: medium">
        {{ error }}
      </p>
      <b-button type="submit" class="w-100 btn-submit">{{ $t('form_register') }}</b-button>
      <p class="mention w-100 text-center mt-3">
        {{ $t('form_alreadyHaveAnAccount') }}
        <router-link class="attribute" to="/Login">{{ $t('nav_login') }}</router-link>
      </p>
    </b-form>
  </div>
</template>

<script>
import RepositoryFactory from "@/repository/factory";
const customerNoAuth = RepositoryFactory.get("customerNoAuth");
export default {
  data() {
    return {
      showModal: false,
      state: null,
      statePass: null,
      statePassRe: null,
      stateEmail: null,
      name: null,
      pass: null,
      passRepeat: null,
      phone: null,
      error: "",
      email: null,
      showPass: false,
      showPassRe: false,
    };
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault();
      this.state = this.statePass = this.stateEmail = this.statePassRe = true;
      if (this.name && this.phone && this.pass && this.email) {
        this.state = null;
        this.statePass = null;
        this.stateEmail = null;
      } else {
        this.state = false;
        this.statePass = false;
        this.stateEmail = false;
        return;
      }
      if (this.pass !== this.passRepeat) {
        return (this.statePassRe = false);
      }

      let body = {
        AppCode: "VGAS247",
        UserFullName: this.name,
        PhoneNumber: this.phone,
        UserEmail: this.email,
        UserPassword: this.pass,
      };

      let res = await customerNoAuth.Register(body);
      let val = res.status ? "success" : "error";
      if ((val === "success")) {
        this.$notify(val, this.$t(val), res.message, {
          duration: 3000,
          permanent: false,
        });
      } else {
        this.$notify(val, this.$t(val), res.message, {
          duration: 3000,
          permanent: false,
        });
        this.error = res.message;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.login-card {
  border-radius: var(--Border-radius-rounded-xl, 12px);
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(25px);
  padding: 16px;
  margin: 0 auto;
  max-width: 416px;
}

.card-title {
  color: var(--Blue-navy---Web, #0c2d57);
  text-align: center;
  /* text-24/font-semibold */
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  /* 36px */
}

.btn-submit {
  padding: 12px 16px;
  border-radius: 8px;
  background: var(--brand-color, #ff9500) !important;
}

.attribute {
  color: var(--System-Colors-Orange, #ff9500);
  /* text-14/font-semibold */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  /* 157.143% */
}

.email-descrip {
  color: var(--System-Colors-Gray, #6b6f80);

  /* text-14/font-regular */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  /* 157.143% */
}

.input-icon {
  font-size: 15px;
  position: absolute;
  top: 50%;
  left: 20px;
  z-index: 9;
  transform: translateY(-50%);
  color: #6b6f80;
}
</style>